var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['question', _vm.setBackground],on:{"click":function($event){return _vm.$emit('selected', _vm.questionId)}}},[_c('span',[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }